export default function(state={}, action){
  switch(action.type) {
    case 'ALL_USERS':
        return {...state, users:action.paylod}
    case 'GET_TRAINERS':
      return {...state, addTrainer:null, trainers:action.paylod}
    case 'ADD_TRAINER':
      return {...state, addTrainer:action.paylod}
    case 'GET_FREE_USERS':
      return {...state, updateFreeUser:null, freeUsers:action.paylod}
    case 'UPDATE_FREE_USER': 
      return {...state, updateFreeUser:action.paylod}
    default:
        return state;
  }
}